import React, { useState, useEffect, useContext } from "react";
import "./Toolbar.scss";
import { previewResume } from "../../Store/Actions/ResumeActions";
import { useDispatch, useSelector } from "react-redux";
import { useParams, withRouter } from "react-router-dom";
import { ExternalUserContext } from "../../Context/externalUserContext";
import LoginPopup from "../Modals/LoginPopup/LoginPopup";

function Toolbar(props) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [blobUrl, setBlobUrl] = useState("");
  const [showLogin, setShowLogin] = useState(false);
  const { isLogin, setIsLogin } = useContext(ExternalUserContext);

  const preview = () => {
    props.setShowPreview(true);
  };
  const resumeDownload = () => {
    if (isLogin && isLogin) {
      dispatch(previewResume(id));
    } else {
      setShowLogin(true);
    }
  };
  const handleOpenModal = () => {
    setShowLogin(true);
  };

  const handleHide = () => {
    setShowLogin(false);
  };

  return (
    <>
      <LoginPopup show={showLogin} hide={handleHide} />
      {/* <div
        className="row toptoolbar d-none d-lg-flex no-gutters"
        style={{ marginRight: "-27px" }}
      >
        <div className="col-md-4 row mb-2">
          <div className="ml-3 mr-2">
            <ResumeButton
              medium
              box_shadow
              className="w-100"
              font_weight
              left_icon
              title="Undo"
              src="/images/undo.svg"
              onClick={props.undo}
            />
          </div>
          <div className="mr-2">
            <ResumeButton
              medium
              box_shadow
              className="w-100"
              font_weight
              left_icon
              title="Redo"
              src="/images/redo.svg"
              onClick={props.redo}
            />
          </div>
        </div>
        {isLogin && isLogin ? (
          ""
        ) : (
          <div
            className="col-md-4 error build-login-error"
            onClick={handleOpenModal}
          >
            Please login to save your work !!!
          </div>
        )}

        <div className={isLogin && isLogin ? "col-md-8" : "col-md-4"}>
          <div className="d-flex justify-content-end mb-2">
            <div className="mr-2">
              <ResumeButton
                medium
                box_shadow
                className="w-100"
                font_weight
                left_icon
                title="Preview"
                src="/images/preview.svg"
                onClick={() => preview()}
              />
            </div>

            <div className="mr-2">
              <ResumeButton
                medium
                box_shadow
                className="w-100 "
                font_weight
                left_icon
                title="Share"
                src="/images/share.svg"
                onClick={() => props.shareShow()}
              />
            </div>

            <div className="">
              <ResumeButton
                medium
                box_shadow
                className="w-100  "
                font_weight
                left_icon
                title="Download"
                src="/images/download.svg"
                onClick={() => resumeDownload()}
              />
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}

export default Toolbar;
